import Alpine from 'alpinejs';

Alpine.store('itineraryShare', {
    shareUrl: '',
    reservationId: '',
    title: '',
    dates: '',
    location: '',
    emails: '',
    copied: false,
    sending: false,
    error: '',
    success: false,

    open() {
        const el = document.querySelector('[data-itinerary-share]');
        if (!el) {
            console.warn('itineraryShare: data-itinerary-share not found');
            return;
        }

        this.shareUrl = el.getAttribute('data-itinerary-share-url') || '';
        this.reservationId = el.getAttribute('data-itinerary-share-reservation-id') || '';
        this.title = el.getAttribute('data-itinerary-share-title') || '';
        this.dates = el.getAttribute('data-itinerary-share-dates') || '';
        this.location = el.getAttribute('data-itinerary-share-location') || '';
        this.copied = false;
        this.error = '';
        this.success = false;
        this.emails = '';

        Alpine.store('modals').open('share-itinerary-modal');
    },

    close() {
        Alpine.store('modals').close('share-itinerary-modal');
    },

    async copyLink() {
        if (!this.shareUrl) return;
        try {
            await navigator.clipboard.writeText(this.shareUrl);
        } catch (err) {
            const input = document.createElement('input');
            input.value = this.shareUrl;
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
        }
        this.copied = true;
        setTimeout(() => {
            this.copied = false;
        }, 2000);
    },

    async sendEmail() {
        this.error = '';
        this.success = false;

        if (!this.reservationId || !this.emails) {
            this.error = 'Please enter at least one email address.';
            return;
        }

        const csrf = window.__csrfToken;

        const formData = new FormData();
        formData.append('reservationId', this.reservationId);
        formData.append('emails', this.emails);
        if (csrf) {
            formData.append(csrf.name, csrf.value);
        }

        this.sending = true;

        try {
            const response = await fetch('/actions/avari/itinerary/send', {
                method: 'POST',
                body: formData,
            });
            const data = await response.json();
            if (data.success) {
                this.success = true;
                this.emails = '';
            } else {
                this.error = data.error || 'Failed to send email.';
            }
        } catch (e) {
            this.error = 'Failed to send email.';
        } finally {
            this.sending = false;
        }
    },
});
